import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { HomeService } from 'src/app/core/http/web/home.service';

@Component({
  selector: 'app-widget-insurance-web',
  templateUrl: './widget-insurance-web.component.html',
  styleUrls: ['./widget-insurance-web.component.scss']
})

export class WidgetInsuranceWebComponent implements OnInit {
	@Input('route') public route: string;
	@Input('widgetData') public widgetData:any = null;
  @Output() propagarWidgetInsurance = new EventEmitter();
  public loadings: any = true;
  public dataServ: any;
  public loadPerParts: boolean;
  public errors: any = null;
	
  constructor(private homeWpServ: HomeService
  ) {}

  ngOnInit() {
  }
  reload() {
    this.loadings = true;
    this.getAllData(this.route);
  }

  getAllData(ruta) {
    this.homeWpServ.getAllDataPage(ruta).subscribe(data => {
      console.log('dataaaa', data)
      console.log('rutaaaa', ruta)

      // this.orden = data.ordenamiento;
      this.dataServ = data;
      this.loadings = false;
    }, err => {
      console.error('Error | el servicio retorno un error:', err);
      this.errors = err;
      this.loadPerParts = true;
      this.dataServ = {};
    });
  }

  procesaPropagarWidget(mensaje){
    //console.log("valor de radio estamos en widget-insurance ",mensaje);
    this.propagarWidgetInsurance.emit(mensaje);
  }
}
